import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=0a234bfd&scoped=true&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"
import style0 from "./Classify.vue?vue&type=style&index=0&id=0a234bfd&scoped=true&lang=scss&"
import style1 from "./Classify.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a234bfd",
  null
  
)

export default component.exports